<div class="logged-in-view">
    <div class="flex flex-col gap-6">
        <!-- Header Section -->
        <div class="flex flex-col 2xl:flex-row md:items-center justify-between gap-4">
            <div>
                <h1 class="text-app-primary-10">Rezept erstellen</h1>
                @if (patient) {
                    <p class="text-app-secondary-10">
                        {{ patient.firstName }} {{ patient.lastName }} •
                        {{ patient.deliveryAddress.street }} {{ patient.deliveryAddress.houseNumber }}
                        , {{ patient.deliveryAddress.zipCode }} {{ patient.deliveryAddress.city }}
                    </p>
                }
            </div>
            <div class="flex flex-col gap-4">
                <div class="flex flex-col sm:flex-row items-center gap-6">
                    <mat-checkbox [(ngModel)]="showOnlyAvailableArticles" (ngModelChange)="changeAvailableState()"
                                  class="text-app-primary-20">
                        Nur verfügbare Artikel
                    </mat-checkbox>
                    <div class="flex flex-col min-w-[150px]">
                        <label class="text-[10px] font-bold text-app-primary-10 uppercase mb-1">THC Gehalt ({{ thcMin }}
                            % - {{ thcMax }}%)</label>
                        <mat-slider min="0" max="30" step="1" discrete>
                            <input matSliderStartThumb [(ngModel)]="thcMin" (change)="onThcChange()">
                            <input matSliderEndThumb [(ngModel)]="thcMax" (change)="onThcChange()">
                        </mat-slider>
                    </div>
                    <div class="flex flex-col min-w-[150px]">
                        <label class="text-[10px] font-bold text-app-primary-10 uppercase mb-1">CBD Gehalt ({{ cbdMin }}
                            % - {{ cbdMax }}%)</label>
                        <mat-slider min="0" max="30" step="1" discrete>
                            <input matSliderStartThumb [(ngModel)]="cbdMin" (change)="onCbdChange()">
                            <input matSliderEndThumb [(ngModel)]="cbdMax" (change)="onCbdChange()">
                        </mat-slider>
                    </div>
                    <div class="flex flex-col min-w-[150px]">
                        <label class="text-[10px] font-bold text-app-primary-10 uppercase mb-1">Preis pro g
                            ({{ priceMin }}€ - {{ priceMax }}€)</label>
                        <mat-slider min="0" max="30" step="1" discrete>
                            <input matSliderStartThumb [(ngModel)]="priceMin" (change)="onPriceChange()">
                            <input matSliderEndThumb [(ngModel)]="priceMax" (change)="onPriceChange()">
                        </mat-slider>
                    </div>
                    <div class="relative w-full sm:w-64">
                        <i class="fa-solid fa-magnifying-glass absolute right-3 top-1/2 -translate-y-1/2 text-app-primary-10/40"></i>
                        <input [formControl]="filterControl" (keyup)="applyFilter()" placeholder="Artikel suchen..."
                               class="w-full pr-10!">
                    </div>
                </div>
            </div>
        </div>

        <div class="grid 2xl:grid-cols-2 gap-8 items-start">
            <!-- Left Side: Prescription Preview (German Recipe Style) -->
            <div class="flex flex-col gap-6 2xl:sticky 2xl:top-6">
                <div class="flex items-center justify-between">
                    <h2 class="text-app-primary-10 flex items-center gap-2">
                        Rezeptvorschau
                        <span class="bg-app-primary-10 text-white text-xs px-2 py-0.5 rounded-full"
                              *ngIf="selectedArticlesFormArray.length > 0">
                            {{ selectedArticlesFormArray.length }} / 3
                        </span>
                    </h2>
                </div>

                <!-- German Prescription Mockup -->
                <div
                    class="bg-[#fef9f0] rounded-sm shadow-md border-[3px] border-red-200 p-6 min-h-[500px] flex flex-col relative overflow-hidden">
                    <!-- Prescription Header -->
                    <div class="flex justify-between items-start border-b-2 border-red-100 pb-4 mb-6">
                        <div class="w-1/2 border border-red-200 p-2 text-[10px] min-h-[80px]">
                            <div class="font-bold text-red-300 mb-1">Patient</div>
                            @if (patient) {
                                <p class="font-medium text-gray-700">{{ patient.firstName }} {{ patient.lastName }}</p>
                                <p class="text-gray-600">{{ patient.deliveryAddress.street }} {{ patient.deliveryAddress.houseNumber }}</p>
                                <p class="text-gray-600">{{ patient.deliveryAddress.zipCode }} {{ patient.deliveryAddress.city }}</p>
                            }
                        </div>
                        <div class="text-right">
                            <div class="text-[8px] font-bold text-red-200 border border-red-100 px-1 inline-block mb-1">
                                Kassen-Nr.
                            </div>
                            <div
                                class="text-[20px] font-black text-red-100/50 -rotate-12 absolute right-4 top-20 select-none">
                                MUSTER
                            </div>
                        </div>
                    </div>

                    <form [formGroup]="recipeForm" class="flex-1 flex flex-col">
                        <div formArrayName="selectedArticles" class="flex flex-col gap-8">
                            @for (selectedCtrl of selectedArticlesFormArray.controls; track selectedCtrl; let j = $index) {
                                <div [formGroupName]="j" class="relative group">
                                    <button (click)="removeSelectedArticle(j, selectedCtrl)"
                                            class="absolute -left-12 top-0 text-red-400 hover:text-red-600 p-2 transition-all opacity-0 group-hover:opacity-100">
                                        <i class="fa-solid fa-circle-xmark text-xl"></i>
                                    </button>

                                    <div class="border-b border-dotted border-gray-400 pb-4">
                                        <div class="flex justify-between items-baseline mb-2">
                                            <div
                                                class="font-bold text-gray-800 text-lg uppercase tracking-tight">{{ selectedCtrl.value.articleName }}
                                            </div>
                                            <div class="flex items-center gap-2">
                                                <input type="number" [min]="0" formControlName="quantityToAdd"
                                                       (keyup)="updateSelectedArticles(selectedCtrl)"
                                                       class="w-16 bg-red-50/50 border-b border-red-200 focus:outline-none text-center font-bold text-gray-800 py-1">
                                                <span
                                                    class="text-sm font-bold text-gray-500">{{ selectedCtrl.value.unitOfMeasurement?.shortName }}</span>
                                            </div>
                                        </div>

                                        <!-- Dosage and Processing per Article -->
                                        <div class="grid grid-cols-2 gap-4 mt-2">
                                            <div class="flex flex-col gap-1">
                                                <label
                                                    class="text-[9px] uppercase font-bold text-red-300">Dosierung</label>
                                                <mat-select formControlName="drugDosage"
                                                            class="text-xs bg-transparent border-b border-gray-100 pb-0.5 outline-none">
                                                    <mat-option [value]="''">Wählen...</mat-option>
                                                    <mat-option [value]="'custom'">Eigene Angabe...</mat-option>
                                                    @for (dosage of drugDosages; track dosage.id) {
                                                        <mat-option [value]="dosage.value">{{ dosage.value }}
                                                        </mat-option>
                                                    }
                                                </mat-select>
                                                @if (selectedCtrl.get('drugDosage')?.value === 'custom') {
                                                    <input type="text" formControlName="customDrugDosage"
                                                           placeholder="Eigene Dosierung..."
                                                           class="mt-1 text-xs bg-red-50/30 border-b border-red-50 outline-none italic">
                                                }
                                            </div>
                                            <div class="flex flex-col gap-1">
                                                <label
                                                    class="text-[9px] uppercase font-bold text-red-300">Verarbeitung</label>
                                                <mat-select formControlName="drugProcessing"
                                                            class="text-xs bg-transparent border-b border-gray-100 pb-0.5 outline-none">
                                                    <mat-option [value]="''">Wählen...</mat-option>
                                                    <mat-option [value]="'custom'">Eigene Angabe...</mat-option>
                                                    @for (processing of drugProcessings; track processing.id) {
                                                        <mat-option [value]="processing.value">{{ processing.value }}
                                                        </mat-option>
                                                    }
                                                </mat-select>
                                                @if (selectedCtrl.get('drugProcessing')?.value === 'custom') {
                                                    <input type="text" formControlName="customDrugProcessing"
                                                           placeholder="Eigene Verarbeitung..."
                                                           class="mt-1 text-xs bg-red-50/30 border-b border-red-50 outline-none italic">
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            } @empty {
                                <div
                                    class="flex-1 flex flex-col items-center justify-center py-20 opacity-20 rotate-[-5deg]">
                                    <i class="fa-solid fa-prescription text-[120px] text-red-300"></i>
                                    <p class="font-bold text-red-400 mt-4 uppercase tracking-widest">Keine Artikel</p>
                                </div>
                            }
                        </div>

                    </form>

                    <!-- Prescription Footer -->
                    <div class="mt-auto pt-8 flex justify-between items-end">
                        <div class="flex flex-col gap-1">
                            <div class="text-[9px] font-bold text-red-300 uppercase">Ausstellungsdatum</div>
                            <div class="border-b border-red-100 min-w-[100px] py-1 text-sm text-gray-600">
                                {{ today }}
                            </div>
                        </div>
                        <div
                            class="w-48 h-20 border-2 border-dashed border-red-100 rounded flex items-center justify-center relative">
                            <span class="text-[8px] font-bold text-red-200 absolute top-1 left-1">Arztstempel / Unterschrift</span>
                            <i class="fa-solid fa-signature text-red-50/50 text-4xl"></i>
                        </div>
                    </div>
                </div>

                <!-- Actions -->
                @if (selectedArticlesFormArray.length > 0) {
                    <div class="flex flex-col gap-4">
                        <div
                            class="bg-white p-4 rounded-xl border border-gray-100 shadow-sm flex justify-between items-center">
                            <div>
                                <span class="text-xs text-gray-400 uppercase font-bold tracking-wider">Gesamtsumme (inkl. MwSt)</span>
                                <div
                                    class="text-2xl font-black text-app-primary-10">{{ (getTotalPrice() * 1.19) | currency:'EUR':'symbol':'1.2-2' }}
                                </div>
                            </div>
                            <button class="btn primary-button"
                                    (click)="isUpdate ? updateRecipe() : createRecipe()">
                                <i class="fa-solid" [class.fa-check]="!isUpdate"
                                   [class.fa-arrows-rotate]="isUpdate"></i>
                                {{ isUpdate ? 'Rezept aktualisieren' : 'Rezept erstellen' }}
                            </button>
                        </div>
                    </div>
                }

                <!-- Pharmacy Selection -->
                <div class="bg-white rounded-xl p-6 border border-gray-100 shadow-sm flex flex-col gap-6">
                    <h2 class="text-app-primary-10 flex items-center gap-2">
                        Apotheke auswählen
                    </h2>
                    <p class="text-app-primary-10/70 text-sm">
                        Wählen Sie eine Apotheke aus unserem Apothekenverbund oder geben Sie eine Wunschapotheke Ihres Patienten an.
                    </p>
                    <p class="text-app-primary-10/60 italic text-xs! flex flex-col gap-2 text-app-secondary-10">
                        <span>Sollte Ihr Patient eine Stamm-Apotheke angelegt haben, wird diese automatisch bei der Erstellung des Rezeptes ausgewählt.</span>
                        <span>Lassen Sie dieses Feld dann einfach frei.</span>
                    </p>

                    <form [formGroup]="pharmacyForm" class="flex flex-col gap-6">
                        <div class="flex flex-col gap-2">
                            <label class="text-xs font-bold text-app-primary-10 uppercase">Apotheke</label>
                            <mat-select formControlName="id" (selectionChange)="checkDisabledState()"
                                        class="text-sm bg-gray-50 rounded-lg border-none p-2 focus:ring-2 focus:ring-app-primary-10/20">
                                <mat-option value="">Bitte wählen</mat-option>
                                <mat-option value="custom">Eigene Apotheke</mat-option>
                                <mat-option value="none">Keine Apotheke (Rezept direkt an Patienten)</mat-option>
                                @for (pharmacy of pharmacyList; track pharmacy.id) {
                                    <mat-option [value]="pharmacy.id">
                                        {{ pharmacy.name }}
                                        @if (pharmacy.id === patient.regularPharmacyId) {
                                            (Standard)
                                        }
                                    </mat-option>
                                }
                            </mat-select>
                        </div>

                        @if (pharmacyForm.get('id')?.value === 'custom') {
                            <div [formGroup]="customPharmacyForm"
                                 class="grid grid-cols-1 md:grid-cols-2 gap-4 p-4 bg-gray-50 rounded-xl border border-gray-100">
                                <div class="md:col-span-2">
                                    <label class="text-[10px] font-bold text-app-primary-10 uppercase">Name der Apotheke</label>
                                    <input matInput formControlName="name" placeholder="Apotheke am Markt"
                                           class="w-full bg-white border-none rounded-lg p-2 text-sm mt-1">
                                </div>
                                <div>
                                    <label class="text-[10px] font-bold text-app-primary-10 uppercase">Straße</label>
                                    <input matInput formControlName="street"
                                           class="w-full bg-white border-none rounded-lg p-2 text-sm mt-1">
                                </div>
                                <div>
                                    <label class="text-[10px] font-bold text-app-primary-10 uppercase">Hausnummer</label>
                                    <input matInput formControlName="houseNumber"
                                           class="w-full bg-white border-none rounded-lg p-2 text-sm mt-1">
                                </div>
                                <div>
                                    <label class="text-[10px] font-bold text-app-primary-10 uppercase">PLZ</label>
                                    <input matInput formControlName="zipCode"
                                           class="w-full bg-white border-none rounded-lg p-2 text-sm mt-1">
                                </div>
                                <div>
                                    <label class="text-[10px] font-bold text-app-primary-10 uppercase">Stadt</label>
                                    <input matInput formControlName="city"
                                           class="w-full bg-white border-none rounded-lg p-2 text-sm mt-1">
                                </div>
                                <div class="md:col-span-2">
                                    <label class="text-[10px] font-bold text-app-primary-10 uppercase">Telefonnummer</label>
                                    <input matInput formControlName="phoneNumber"
                                           class="w-full bg-white border-none rounded-lg p-2 text-sm mt-1">
                                </div>
                            </div>
                        }
                    </form>
                </div>
            </div>

            <!-- Right Side: Article Selection List -->
            <div class="flex flex-col gap-6">
                <h2 class="text-app-primary-10 flex items-center gap-2">
                    Artikelkatalog
                </h2>

                <div class="grid grid-cols-1 gap-4">
                    <form [formGroup]="recipeForm">
                        <div formArrayName="articles" class="flex flex-col gap-3">
                            @for (articleCtrl of articlesFormArray.controls; track articleCtrl; let i = $index) {
                                <div [formGroupName]="i"
                                     class="bg-white rounded-xl p-4 border border-gray-100 shadow-sm hover:border-app-primary-10/30 transition-all group relative overflow-hidden"
                                     [class.ring-2]="articleCtrl.value.inRecipe"
                                     [class.ring-app-primary-10]="articleCtrl.value.inRecipe"
                                     [class.opacity-50]="articleCtrl.value.quantity === 0">

                                    <div class="flex items-center gap-4">
                                        <!-- Minimal Info -->
                                        <div class="flex-1">
                                            <div class="flex items-center gap-2 mb-1">
                                                <div
                                                    class="font-bold text-app-primary-20 leading-tight group-hover:text-app-primary-10 transition-colors">
                                                    {{ articleCtrl.value.articleName }}
                                                </div>
                                            </div>

                                            <div class="flex items-center gap-3">
                                                <span
                                                    class="text-[10px] text-gray-400">PZN: {{ articleCtrl.value.articleNumber }}</span>
                                                <span
                                                    class="text-[10px] font-bold text-app-primary-10">{{ articleCtrl.value.nettoPrice | currency:'EUR':'symbol':'1.2-2' }}</span>
                                            </div>
                                            <div class="flex items-center gap-2 mt-1">
                                                @if (articleCtrl.value.thc) {
                                                    <span
                                                        class="text-[10px] bg-red-50 text-red-600 px-1.5 py-0.5 rounded font-bold">THC: {{ articleCtrl.value.thc }}
                                                        %</span>
                                                }
                                                @if (articleCtrl.value.cbd) {
                                                    <span
                                                        class="text-[10px] bg-blue-50 text-blue-600 px-1.5 py-0.5 rounded font-bold">CBD: {{ articleCtrl.value.cbd }}
                                                        %</span>
                                                }
                                            </div>
                                            <div class="flex items-center gap-3 mt-1">
                                                <span class="text-[10px] text-gray-400">Auf Lager: </span>
                                                <span
                                                    class="text-[10px] font-bold text-app-primary-10">{{ articleCtrl.value.quantity }}</span>
                                            </div>
                                        </div>

                                        <!-- Quantity and Add -->
                                        <div class="flex items-center gap-3">
                                            <div
                                                class="flex items-center gap-2 bg-gray-50 rounded-lg px-2 py-1 border border-gray-100">
                                                <input type="number" formControlName="quantityToAdd" [min]="0"
                                                       class="w-10 bg-transparent border-none focus:outline-none text-center font-bold text-app-primary-20 text-sm">
                                                <span
                                                    class="text-[10px] text-gray-400">{{ articleCtrl.value.unitOfMeasurement?.shortName }}</span>
                                            </div>
                                            <button (click)="updateSelectedArticles(articleCtrl)"
                                                    [disabled]="articleCtrl.value.quantity === 0"
                                                    class="bg-app-primary-10 hover:bg-app-primary-20 text-white h-10 w-10 rounded-xl flex items-center justify-center transition-all active:scale-95 shadow-md shadow-app-primary-10/10 disabled:opacity-30">
                                                <i class="fa-solid" [class.fa-plus]="!articleCtrl.value.inRecipe"
                                                   [class.fa-check]="articleCtrl.value.inRecipe"></i>
                                            </button>
                                        </div>
                                    </div>

                                    @if (articleCtrl.value.characteristics && articleCtrl.value.characteristics.length > 0) {
                                        <div class="flex flex-wrap gap-1 mt-2">
                                            @for (char of articleCtrl.value.characteristics; track char) {
                                                <span
                                                    class="text-[8px] bg-gray-50 text-gray-400 px-1.5 py-0.5 rounded uppercase font-bold">{{ char.name }}</span>
                                            }
                                        </div>
                                    }
                                    @if (articleCtrl.value.conditions) {
                                        <div class="flex flex-wrap gap-1 mt-2">
                                            @for (cond of articleCtrl.value.conditions; track cond) {
                                                <span
                                                    class="text-[10px] bg-purple-50 text-purple-700 px-1.5 py-0.5 rounded font-bold">{{ cond.name }}</span>
                                            }
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    </form>

                    @if (actualPaging) {
                        <div class="mt-4 bg-white rounded-xl border border-gray-100 overflow-hidden">
                            <mat-paginator
                                [length]="actualPaging.totalItems"
                                [pageSize]="actualPaging.pageSize"
                                [pageIndex]="actualPaging.pageNumber - 1"
                                showFirstLastButtons
                                [pageSizeOptions]="[5, 10, 15, 20]"
                                (page)="onPageChange($event)"
                                class="!bg-transparent"
                            ></mat-paginator>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>
